var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineStore } from 'pinia';
import ApiCommon from '@common/api/apiCommon';
import { apiErrorsHandle } from '@common/utils/Helpers/Helpers';
export var useEmployeeCardStore = defineStore('employeeCard', {
    state: function () { return ({
        loading: false,
        visible: false,
        isChatHide: false,
        employee: {
            id: null,
            lastActiveDate: null,
            user: {
                aboutSelf: null,
                avatar: null,
                id: null,
                lastActiveDate: null,
                name: '',
                userChangePassword: false,
                uuid: null,
                email: '',
            },
            school: {},
            role: '',
            comment: '',
            visibilityInStudentDialogues: '',
            lastCourseFinishedAt: null,
            contactBiography: null,
            contactPhone: null,
            contactVk: null,
            contactTg: null,
            requestMissingUserData: false,
            useSchoolCustomEmployeeRole: false,
            employeeAllCourseAccess: false,
            schoolCustomEmployeeRoleActions: [],
            schoolEmployeeRole: {
                uuid: '',
                name: '',
                icon: 'teacher-role',
                actions: [],
                role: 'ROLE_EMPLOYEE',
                usersCount: 0,
                isOwner: false
            },
            courses: [],
            owner: false
        }
    }); },
    actions: {
        show: function () {
            this.visible = true;
        },
        hide: function () {
            this.visible = false;
        },
        getEmployee: function (uuid) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this.employee.user.uuid === uuid) {
                                return [2 /*return*/];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            this.loading = true;
                            _a = this;
                            return [4 /*yield*/, ApiCommon.getEmployee(uuid)];
                        case 2:
                            _a.employee = (_b.sent()).data;
                            return [3 /*break*/, 5];
                        case 3:
                            err_1 = _b.sent();
                            apiErrorsHandle(err_1, {});
                            this.hide();
                            return [3 /*break*/, 5];
                        case 4:
                            this.loading = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    }
});
